<template>
    <pg-page title="Private Gym voor Personal Trainers"
             header="Onbeperkt trainen bij Private Gym?"
             id="voor-pts"
    >

        <div class="mx-auto mt-4">
            <p class="lead mb-4">
                Een eigen studio is prijzig, en in de zomer traint het ook net zo lekker buiten. Maar af en toe knallen met een klant op een krachthonk van Private Gym is goed voor de variatie. Altijd droog, alles bij de hand, en lekker rustig.
            </p>
            <p class="lead mb-4">
                Voor Personal Trainers hebben we een speciaal aanbod. Neem je eigen klanten mee en train zo vaak je wilt. En als je er voor open staat, kunnen we je zelfs koppelen aan andere Private Gym trainees.
            </p>
            <p class="lead mb-4">
                Meer informatie? Laat je nummer achter, dan bellen we je zo snel mogelijk terug.
            </p>
        </div>

        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-0  border-bottom border-top py-4">
            <a type="button" class="btn btn-dark btn-lg px-4 me-sm-3 col-sm-6" @click.prevent="showFormModal = true">
                <i class="bi bi-chevron-right" style="margin-right: 12px;"></i>
                Contact mij
            </a>
            <a type="button" class="btn btn-success btn-lg px-4 col-sm-6" href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym%20als%20Personal%20trainer" rel="_blank">
                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i>
                <span style="display: inline-block;">
                                    WhatsApp
                                </span>
            </a>
        </div>


        <contact-modal
            v-if="showFormModal"
            @closed="showFormModal = false"
            type="pts"
        ></contact-modal>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
export default {
    components: {ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
